/* ui/game/configuration/AIDropdown.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	select_option,
	select_value,
	space,
	text
} from "svelte/internal";

import ai from "../../../game/ai/ArchiveOfGreatnesss/";
import { game } from "../../store";

import {
	playerOne,
	playerTwo,
	playerAI,
	playerOneStore,
	playerTwoStore
} from "../../../stores/player_store";

function add_css() {
	var style = element("style");
	style.id = "svelte-6jc058-style";
	style.textContent = ".container.svelte-6jc058{display:grid;grid-template-columns:1fr 1fr}select.svelte-6jc058{font-size:.7em}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

// (30:4) {#each options as option}
function create_each_block_1(ctx) {
	let option;
	let t0_value = /*option*/ ctx[6].displayName + "";
	let t0;
	let t1;
	let option_value_value;
	let option_selected_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*option*/ ctx[6];
			option.value = option.__value;
			option.selected = option_selected_value = /*option*/ ctx[6] === playerOne;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (41:4) {#each options as option}
function create_each_block(ctx) {
	let option;
	let t0_value = /*option*/ ctx[6].displayName + "";
	let t0;
	let t1;
	let option_value_value;
	let option_selected_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*option*/ ctx[6];
			option.value = option.__value;
			option.selected = option_selected_value = /*option*/ ctx[6] === playerTwo;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let label0;
	let t1;
	let select0;
	let t2;
	let div1;
	let label1;
	let t4;
	let select1;
	let mounted;
	let dispose;
	let each_value_1 = /*options*/ ctx[2];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*options*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div0 = element("div");
			label0 = element("label");
			label0.textContent = "Player One:";
			t1 = space();
			select0 = element("select");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t2 = space();
			div1 = element("div");
			label1 = element("label");
			label1.textContent = "Player Two:";
			t4 = space();
			select1 = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(select0, "class", "svelte-6jc058");
			if (/*selectedPlayerOne*/ ctx[0] === void 0) add_render_callback(() => /*select0_change_handler*/ ctx[4].call(select0));
			attr(div0, "class", "container svelte-6jc058");
			attr(select1, "class", "svelte-6jc058");
			if (/*selectedPlayerTwo*/ ctx[1] === void 0) add_render_callback(() => /*select1_change_handler*/ ctx[5].call(select1));
			attr(div1, "class", "container svelte-6jc058");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			append(div0, label0);
			append(div0, t1);
			append(div0, select0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(select0, null);
			}

			select_option(select0, /*selectedPlayerOne*/ ctx[0]);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			append(div1, label1);
			append(div1, t4);
			append(div1, select1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select1, null);
			}

			select_option(select1, /*selectedPlayerTwo*/ ctx[1]);

			if (!mounted) {
				dispose = [
					listen(select0, "change", /*select0_change_handler*/ ctx[4]),
					listen(select0, "change", /*reloadAI*/ ctx[3]),
					listen(select1, "change", /*select1_change_handler*/ ctx[5]),
					listen(select1, "change", /*reloadAI*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*options, playerOne*/ 4) {
				each_value_1 = /*options*/ ctx[2];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(select0, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*selectedPlayerOne, options*/ 5) {
				select_option(select0, /*selectedPlayerOne*/ ctx[0]);
			}

			if (dirty & /*options, playerTwo*/ 4) {
				each_value = /*options*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*selectedPlayerTwo, options*/ 6) {
				select_option(select1, /*selectedPlayerTwo*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div0);
			destroy_each(each_blocks_1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let selectedPlayerOne;
	let selectedPlayerTwo;
	let options = [playerAI, ...ai];

	function reloadAI() {
		playerOneStore.update(() => selectedPlayerOne);
		playerTwoStore.update(() => selectedPlayerTwo);
		game.reset();
	}

	function select0_change_handler() {
		selectedPlayerOne = select_value(this);
		$$invalidate(0, selectedPlayerOne);
		$$invalidate(2, options);
	}

	function select1_change_handler() {
		selectedPlayerTwo = select_value(this);
		$$invalidate(1, selectedPlayerTwo);
		$$invalidate(2, options);
	}

	return [
		selectedPlayerOne,
		selectedPlayerTwo,
		options,
		reloadAI,
		select0_change_handler,
		select1_change_handler
	];
}

class AIDropdown extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-6jc058-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default AIDropdown;